import React from 'react';
import './BaseButton.scss'

export default function BaseButton({onClick, buttonStyle, label}) {
    return (
        <button onClick={onClick} style={buttonStyle}
                className={'m-0 flex justify-center items-center w-full p-3 py-4 rounded-sm focus:bg-none'}>
            {label}
        </button>
    );
}
